import { html, LitElement } from 'lit';
import lottie from 'lottie-web';

import { buildURL } from 'Utils/api-fetch-request';

import Styles from './vm-chatbot-skeleton.scss';

const _MESSAGES = {
    inline: ['Summarizing...'],
    modal: ['Understanding Vumedi videos...', 'Searching most recent updates...', 'Finding relevant videos...'],
};

const _SKELETON_LINE_COUNT = 12;
const _TEASER_INTERVAL = 3000;

export default class VmChatbotSkeleton extends LitElement {
    static properties = {
        _activeTeaserText: { state: true },

        dataHidden: { type: Boolean, attribute: 'data-hidden' },
        // Possible values: 'inline', 'modal', default is 'inline'
        dataType: { type: String, attribute: 'data-type' },
    };

    static styles = Styles;

    activeTeaserInterval = null;

    firstUpdated() {
        this.loadAnimation();
        this.setTeaserText();
    }

    getMessages() {
        if (!_MESSAGES[this.dataType]) {
            return _MESSAGES.inline;
        }

        return _MESSAGES[this.dataType];
    }

    loadAnimation() {
        const animationPath = document.querySelector('meta[name="lottie-ai-answer"]')?.content;

        if (!animationPath) {
            return;
        }

        const animation = lottie.loadAnimation({
            name: `answer-${this.dataType}`,
            container: this.renderRoot.querySelector('.teaser-message-avatar'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: buildURL(animationPath, { name: `vm-chatbot-skeleton-${this.dataType}` }),
        });

        animation.addEventListener('DOMLoaded', () => {
            animation.setSpeed(0.66);
            animation.playSegments([45, 164], true);
        });
    }

    setTeaserText() {
        if (this.activeTeaserInterval) {
            clearInterval(this.activeTeaserInterval);
            this.activeTeaserInterval = null;
        }

        const messages = this.getMessages();

        if (messages.length === 1) {
            return;
        }

        let activeTeaserIndex = 0;

        this.activeTeaserInterval = setInterval(() => {
            activeTeaserIndex = ++activeTeaserIndex % messages.length;
            this._activeTeaserText = messages[activeTeaserIndex];
        }, _TEASER_INTERVAL);
    }

    renderSkeletonLines() {
        const lines = [];

        for (let i = 0; i < _SKELETON_LINE_COUNT; i++) {
            lines.push(html`<div class="line"></div>`);
        }

        return lines;
    }

    render() {
        const teaserText = this._activeTeaserText ?? this.getMessages()[0];

        return html`
            <div class="teaser-message-wrap">
                <div class="teaser-message-avatar"></div>
                <div class="teaser-message-text">${teaserText}</div>
            </div>
            <div class="lines-wrap">${this.renderSkeletonLines()}</div>
        `;
    }
}

customElements.define('vm-chatbot-skeleton', VmChatbotSkeleton);
